import {FILE_TYPE} from "../../../../services/export/ExportService";
import {textFilterParamsValues} from "../../reactTableController";
import AwInputCheckBox from "../../../react/AwInputCheckBox";
export const defaultSortModel = [
    {
        colId: 'reportName',
        sort: 'asc',
        sortIndex: 1
    },
    {
        colId: 'active',
        sort: "desc",
        sortIndex: 0,
    }
];
export const reactUserReportCols = function ( translate, docTypesPromise, levelOptionsPromise) {
    return [ {
        field: "reportName",
        headerName: translate.instant('REPORT_NAME'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "documentType",
        sortable: true,
        headerName: translate.instant('REPORT_TYPE'),
        filter: "agSetColumnFilter",
        valueGetter: (params) =>{
            return params.data ? translate.instant(params.data.documentType) : "";
        },
        filterParams: {
            values: (params) => {
                docTypesPromise.then(data => {
                    for(let i=0; i < data.length; i++) {
                        // remove xls file types
                        if(!data[i].code.startsWith(FILE_TYPE.XLSX.value) && data[i].code.startsWith(FILE_TYPE.XLS.value)) {
                            data[i].code = data[i].code.replace(FILE_TYPE.XLS.value, FILE_TYPE.XLSX.value);
                        }
                    }
                    params.success(data.map(it => it.code));
                });
            },
            valueFormatter:  (params) => {
                return translate.instant(params.value);
            }
        }
    },{
        field: "active",
        sortable: true,
        headerName: translate.instant('ACTIVE'),
        filter: "agSetColumnFilter",
        filterParams: { values: ['INACTIVE', 'ACTIVE'],
            valueFormatter: (params) => {
                return translate.instant(params.value)
            }},
        cellRenderer: AwInputCheckBox,
        cellRendererParams: {property: 'active'}
    },{
        field: "access",
        headerName: translate.instant('ACCESS'),
        sortable: true,
        filter: 'agSetColumnFilter',
        filterParams: {values: params => levelOptionsPromise.then(data => params.success(data))}
    },{
        field: "editing",
        headerName: translate.instant('EDITING'),
        sortable: true,
        filter: 'agSetColumnFilter',
        filterParams: {values: params => levelOptionsPromise.then(data => params.success(data))}
    }];
}
